export default function Loader() {
  return (
    <>
      <div className="flex items-center w-[400px] h-[400px]">
        <video id="banner-video" preload="none" playsInline muted loop autoPlay>
          <source src="/images/sticker.webm" type="video/webm" />
        </video>
      </div>
    </>
  );
}
